/**
 * Reads the new entry's documentId from a successful Strapi create response,
 * which has the shape `{ data: { documentId, ... } }`.
 *
 * Returns undefined instead of throwing when the body is not JSON or carries
 * no documentId: the entry was created either way, so the caller must not
 * report the create as failed just because the id is unreadable.
 *
 * @param response A response whose `ok` status the caller has already checked.
 * @returns The documentId, or undefined when the body does not contain one.
 */
export async function readCreatedDocumentId(response: { json: () => Promise<unknown> }): Promise<string | undefined> {
  let body: unknown;
  try {
    body = await response.json();
  } catch (error) {
    console.warn('[strapi] create response body was not JSON; documentId unavailable', error);
    return undefined;
  }
  const documentId = (body as { data?: { documentId?: unknown } } | null)?.data?.documentId;
  return typeof documentId === 'string' && documentId.length > 0 ? documentId : undefined;
}
